module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"inventories":"Inventuren","noInventoriesAvailable":"Keine Inventuren vorhanden"},"en":{"inventories":"Inventories","noInventoriesAvailable":"No inventories available"}}')
  delete Component.options._Ctor
}
